import * as keyapis_ecosystem_v1_lego_adapter_pb from "./v1/keyapis_ecosystem_lego_adapter_v1.pb";
import * as keyapis_ecosystem_v1_system_pb from "./v1/keyapis_ecosystem_system_v1.pb";

export default {
  v1: {
    resources: {
      legoAdapter: keyapis_ecosystem_v1_lego_adapter_pb,
      system: keyapis_ecosystem_v1_system_pb,
    },
  },
};
